<template>
  <div class="colours-palette">
    <div class="container">
      <div class="row">
        <div :style="{ width: (100/processedColours.length) + '%'}" v-for="colour in processedColours">
          <div class="color-thumbnail"
               v-bind:style="{ backgroundColor: parseColour(colour), padding: height + 'px 0'}"
          >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "VerticalColourPalette",
  props: ['colours', 'height', 'count'],
  data: () => {
      return {
          processedColours: [],
      };
  },
  mounted() {
    let array = [...new Set(this.colours)];

    if(this.count) {
      let startPosition = (this.count - array.length);
      let delCount = (array.length - this.count);
      let rDelCount, lDelCount;
      if(delCount > 1) {
        rDelCount = Math.floor(delCount/2);
        lDelCount = Math.ceil(delCount/2);

        array.splice(0, lDelCount);
        array.splice(startPosition, rDelCount);
      } else {
        array.splice(startPosition, delCount);
      }
    }
    this.processedColours = array.filter(function (el) {
      return el != null;
    });
  },
  methods: {
    parseColour(colour) {
      if (typeof colour === 'string') {
        return colour;
      } else if (colour) {
        return '#' + colour.code;
      } else {
        return colour;
      }

    }
  }
}
</script>

<style scoped>

</style>
